import React, { Component } from 'react';
import * as d3 from 'd3';

import ChartSpecs from '../data/chart_specs';

import VillagerAvatar from '../components/VillagerAvatar';
import LeafSvgUrl from '../images/leaf.svg';
import Dialogue from '../components/Dialogue';

//images
import ImgAnkhaHouse from '../images/house/House_of_Ankha_NH.jpeg';
import ImgAnkha from '../images/villagers/Ankha.png';


const colorWheelObj = ChartSpecs.chartspecs.colorWheelObjBoolean
var colorWheelArray = Object.keys(colorWheelObj);
var colorRange = Object.values(colorWheelObj);
var margin = ChartSpecs.chartspecs.margin;


class VillagerHouse extends Component {
  constructor(props){
      super(props);
      this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;
      this.tierNodes = {};
   }

   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);
     this.drawStackBarChart();
   }

    drawStackBarChart(){
      var svg = this.svg,
          chartWidth = this.svgRef.current.clientWidth,
          chartHeight = 430,
          stackKeys = colorWheelArray,
          radius = 40,
          tooltip = d3.select('#tooltip-house'),
          skinColors =  this.props.villagerSkinColors,
          textColors =  this.props.villagerTextColors;

      let allVillagers = this.allVillagers;

      /* COLOR NODES SORT */
      //let tierNodes = d3.group(allVillagers, d => d.tier);
      let tierNodes = d3.groups(allVillagers, d => d.tier, d => d.Combined_Special_House_Style);
      let tierNodes2 = d3.rollup(allVillagers, v => v.length, d => d.tier, d => d.Combined_Special_House_Style);
      let tierArray = [...tierNodes2.keys()];

      let tableData = Array.from(tierNodes2.entries())
      .map(g => {
        const obj = {};
        obj["tier"] = g[0];
        for (let col of stackKeys) {
          const vals = g[1].get(col);
          obj[col] = !vals ? 0 : vals;
        }
        return obj;
      })
     .sort((a, b) => a["tier"] - b["tier"]);




      chartHeight = tierNodes.length * radius + margin.top + margin.bottom

      const yScale = d3.scaleBand()
            //.domain(tierNodes.map(d => d[0])) //tiers
            .domain(tierArray)
            .range([margin.top, chartHeight - margin.bottom])
            .padding(0.25)

      const xScale= d3.scaleLinear()
                    .range([margin.left, chartWidth - margin.right])


      const colorScale = d3.scaleOrdinal()
                  .domain(colorWheelArray)
                  .range(colorRange)

      const xAxis = g => g
                  .attr("transform", `translate(0,${margin.top+10})`)
                  .call(d3.axisTop(xScale).ticks(chartWidth / 100, "%"))
                  .call(g => g.selectAll(".domain").remove());

      const yAxis = g => g
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(yScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                .call(g => g.selectAll(".domain").remove())


      const formatPercent = d3.format(".1%");
      const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")
      /* set up mutiple colli  */
      let basePerRow = 10,
          baseRowWidth = (chartWidth + 0) / (basePerRow + 1);

      const series = d3.stack()
                    .keys(stackKeys)
                    .offset(d3.stackOffsetExpand)
                  (tableData)
                    .map(d => (d.forEach(v => v.key = d.key), d))

      svg.attr("id", 'uniqueHouseChart');
      svg.attr("height", chartHeight);

      svg.append("g")
      .call(xAxis);

      svg.append("g")
      .attr("class", 'yaxis tier-axis no-tick')
      .call(yAxis);

      svg.append("g")
        .selectAll("g")
        .data(series)
        .join("g")
        .attr("fill", d => colorScale(d.key))
        .selectAll("rect")
        .data(d => d)
        .join("rect")
          .attr("x", d => xScale(d[0]))
          .attr("y", (d, i) => yScale(d.data.tier))
          .attr("width", d => xScale(d[1]) - xScale(d[0]))
          .attr("height", yScale.bandwidth())
          .on("mouseenter", function(e,d) {
             const x = xScale(d[0]) + (xScale(d[1]) - xScale(d[0])) / 2;
             const y = yScale(d.data.tier);

             let thisBar = d3.select(this);


             d3.select('#tooltip-house')
                         .transition()
                         .duration(200)
                         .style("display", "block");

             d3.select('#tooltip-house')
               .html(
                 `<p> <b>${formatValue(d.data[d.key])}</b> villagers </p>`
               ).style(
                     "transform",
                     `translate(` + `calc( -50% + ${x}px),` + `calc(-100% + ${y}px)` + `)`
                   );

              d3.select(this).transition()
                     .duration(350)
                     .style("stroke", d => colorScale(d.key))

           })
           .on('mouseleave', function() {
             d3.select('#tooltip-house')
               .transition()
               .duration(200)
               .style("display", "none")

             d3.select(this)
               .transition()
               .style("stroke", 'none')
           })


    }

  render() {
    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-traits">
        <h2 className="title">Special house styles</h2>
        <p className="paragraph">Just like a villager might have a unique character design, some villagers have unique house decor that reflects their personality. For example:</p>
        <div className="unique-villagers">
          <div className="unique-villager unique-house">
            <img alt='Ankha' src={ImgAnkha}/>
            <span className="description">
              <span className="name">Ankha <span className="ranking">14</span></span>
              <span className="sub">A cat with a Egyptian tomb like house</span>
            </span>
            <img className="house" alt='Ankha House' src={ImgAnkhaHouse}/>
          </div>
        </div>
        <p className="paragraph">So much effort went into the interior design of these special houses, so we were curious if having a special house style made a villager more popular.</p>
        <p className="paragraph"> We labeled each villager based on whether they had a <span className="unique-square unique">unique house style</span>  and looked at the distribution of those villagers across the popularity rankings. </p>
        <div className="svg-wrapper">
          <div id="tooltip-house" className="bar-tooltip"></div>
          <svg ref={this.svgRef} width="100%"></svg>
        </div>
        <p className="paragraph">While there isn’t a very strong downward trend visible, Tier 1 does have the highest amount of special house styles at <b>22.5% </b>, and it does look like special house styles appear more in the <b>top 5 tiers</b> compared to the <b> bottom 5 tiers </b>.</p>
        <Dialogue title="Summary" type="regular">
          <p className="paragraph">Having a special house style may give a villager a slight edge in popularity, but it’s not one of the strongest predictors.</p>
        </Dialogue>
      </div>
    )
  }
}

export default VillagerHouse;
